import React from "react";
import { makeStyles, createTheme } from "@material-ui/core/styles";
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  IconButton,
  Link,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@material-ui/core";
import Modal from "@material-ui/core/Modal";
import { Grid } from "@material-ui/core";
import { Button, Label } from "reactstrap";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import { ThemeProvider } from "@material-ui/styles";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import { Autocomplete } from "@material-ui/lab";
import CloseIcon from "mdi-react/CloseIcon";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const defaultMaterialTheme = createTheme({});

const useStyles = makeStyles((theme) => ({
  modalRoot: {
    display: "flex",
    margin: theme.spacing(1),
  },
  modalContentScrollable: {
    maxHeight: `calc(100vh - 85px)`, // 100vh - un margen (puedes ajustar el 8)
    overflowY: "auto", // Habilita el scroll vertical
    paddingRight: theme.spacing(2), // Opcional: añade un poco de espacio para la barra de scroll
    paddingBottom: theme.spacing(2),
    flexGrow: 1,
  },
  overrides: {
    disabled: {
      "& .MuiInputBase-input.Mui-disabled": {
        // Importante para TextField, ya que usa -webkit-text-fill-color
        WebkitTextFillColor: "blue !important",
        color: "red",
      },
    },
  },
}));

export function GeneralModal({
  open,
  title,
  titleAlert,
  onClose,
  fields,
  formData,
  onFieldChange,
  onFieldChangeMini,
  onFieldChangeMay,
  onSave,
  setFormData,
  initialFormData,
  //enableDocumentarytype,
  isEditMode,
  setIsEditMode,
  isView,
  setIsView,
  requiredFields = [],
  children,
  width,
  height,
  isModalRol,
  enableUpdate,
  isModalRadication,
  isUploadDoc = undefined,
  loadRemitente,
  isModalUser = undefined,
  enableDobleAutentication,
  isRegister,
}) {
  const classes = useStyles();
  const fileInputRef = React.useRef(null);
  const [validationErrors, setValidationErrors] = React.useState({});
  const [selectedDocId, setSelectedDocId] = React.useState(null);
  const [selectedFiles, setSelectedFiles] = React.useState({});

  React.useEffect(() => {
    if (!open) {
      setValidationErrors({});
    }
    return () => {
      setFormData(initialFormData || {});
      isView ? setIsView(false) : null;
    };
  }, []);

  const validateForm = () => {
    const errors = {};
    let isValid = true;

    const dataCopy = { ...(formData || {}) };
    const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;

    requiredFields.forEach((fieldName) => {
      let value = dataCopy[fieldName];

      if (
        fieldName === "telefono_fijo" ||
        fieldName === "celular" ||
        fieldName === "celular_representante"
      ) {
        const digits = String(value || "").replace(/\D/g, "");
        if (digits.length !== 10) {
          isValid = false;
          const field = fields.find((f) => f.name === fieldName);
          errors[fieldName] = `El campo ${
            field ? field.label : fieldName
          } debe contener 10 dígitos.`;
          return;
        }
      }

      if (fieldName === "checkbox-boolean" && value !== true) {
        isValid = false;
        const field = fields.find((f) => f.name === fieldName);
        errors[fieldName] = `Es obligatorio aceptar: ${field.label}`;
        return;
      }

      if (fieldName === "radio" && value !== true) {
        isValid = false;
        const field = fields.find((f) => f.name === fieldName);
        errors[fieldName] = `Es obligatorio aceptar: ${field.label}`;
        return;
      }

      if (
        fieldName === "email" &&
        typeof value === "string" &&
        value.length > 0
      ) {
        emailRegex.lastIndex = 0;

        if (!emailRegex.test(value)) {
          isValid = false;
          const field = fields.find((f) => f.name === fieldName);
          errors[fieldName] = `El campo ${
            field ? field.label : fieldName
          } no tiene un formato de correo electrónico válido.`;
        }
      }

      if (
        value === null ||
        value === undefined ||
        (typeof value === "string" && value.trim() === "") ||
        (Array.isArray(value) && value.length === 0)
      ) {
        isValid = false;
        const field = fields.find((f) => f.name === fieldName);
        errors[fieldName] = `El campo ${
          field ? field.label : fieldName
        } es obligatorio.`;
      }

      if (!isEditMode) {
        const p1 = dataCopy["password"] || "";
        const p2 = dataCopy["password2"] || "";

        // Validación de longitud mínima
        if (p1.length > 0 && p1.length < 6) {
          isValid = false;
          errors["password"] =
            "La contraseña debe tener al menos 6 caracteres.";
        }

        if (p2.length > 0 && p2.length < 6) {
          isValid = false;
          errors["password2"] =
            "La contraseña debe tener al menos 6 caracteres.";
        }

        // Validación de igualdad
        if (p1 && p2 && p1 !== p2) {
          isValid = false;
          errors["password2"] = "Las contraseñas no coinciden.";
        }
      }
    });

    setValidationErrors(errors);

    if (isValid) {
      setFormData(dataCopy);
      return dataCopy;
    }

    return false;
  };

  const handleSave = () => {
    const validated = validateForm();
    if (validated) {
      onSave(validated, selectedFiles);
    }else{
      alert("Detectamos que la información suministrada no está completa o presenta inconsistencias. Revisa los datos del formulario para asegurar que todo esté correcto y puedas finalizar el proceso")
    }
  };

  const handleFileChange = (event, fieldName) => {
    const file = event.target.files[0];

    onFieldChange({
      target: {
        name: fieldName,
        value: file,
      },
    });
  };

  const handleListFileChange = (e, documentType) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFiles((prev) => ({
        ...prev,
        [documentType]: file, // Guardamos el archivo usando el id del documento como llave
      }));
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      className={classes.modalRoot}
    >
      <div
        className="paperAppointment-flex"
        style={{
          padding: 25,
          width: width || "24%",
          height: height || "auto",
        }}
      >
        <div className="subtitle-mod" style={{ marginBottom: "8px" }}>
          <h4>
            {title
              ? title
              : `${
                  isView
                    ? "Información "
                    : isEditMode
                      ? "Actualizar "
                      : "Crear "
                }${titleAlert}`}
          </h4>
        </div>

        <div className={classes.modalContentScrollable}>
          <Grid
            container
            spacing={isModalRol || isModalRadication || isModalUser ? 3 : 1}
            direction={
              isModalRol || isModalRadication || isModalUser ? "row" : "column"
            }
            justifyContent={
              isModalRol || isModalRadication || isModalUser
                ? "flex-start"
                : "center"
            }
          >
            {fields.map((field) => {
              const hasError = !!validationErrors[field.name];
              const helperText = hasError ? validationErrors[field.name] : "";

              // If field.hidden is true, do not render the field
              if (field.hidden) {
                return null;
              }
              return (
                <React.Fragment key={field.name}>
                  {field.type === "select" ? (
                    <Grid
                      item
                      xs={isModalRadication ? 3 : isModalUser ? 4 : 12}
                    >
                      <TextField
                        required
                        select
                        id={field.name}
                        name={field.name}
                        label={field.label}
                        className="medical-material-form__field field-appointment-mod"
                        value={formData[field.name] || ""}
                        onChange={onFieldChange}
                        fullWidth
                        style={{
                          marginBottom: isModalRadication ? "0px" : "5px",
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        disabled={isView}
                        error={hasError}
                        helperText={helperText}
                      >
                        {field.options.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                  ) : field.type === "date" ? ( // ⚠️ Opción 2: Nuevo Campo DatePicker
                    <Grid item xs={isModalRol ? 2 : isModalUser ? 4 : 12}>
                      <MuiPickersUtilsProvider utils={MomentUtils}>
                        <ThemeProvider theme={defaultMaterialTheme}>
                          <DatePicker
                            className="medical-material-form__field field-appointment-mod"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            variant="inline"
                            style={{ marginBottom: "5px" }}
                            label={field.label}
                            value={formData[field.name] || null}
                            onChange={(date) => {
                              onFieldChange({
                                target: {
                                  name: field.name,
                                  value: date,
                                },
                              });
                            }}
                            format="DD/MM/yyyy"
                            animateYearScrolling
                            disabled={isEditMode || isView}
                            fullWidth
                          />
                        </ThemeProvider>
                      </MuiPickersUtilsProvider>
                    </Grid>
                  ) : field.type === "fechaNaci" ? (
                    <Grid item xs={isModalRol ? 2 : isModalUser ? 4 : 12}>
                      <MuiPickersUtilsProvider utils={MomentUtils}>
                        <ThemeProvider theme={defaultMaterialTheme}>
                          <DatePicker
                            className="medical-material-form__field field-appointment-mod"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            variant="inline"
                            style={{ marginBottom: "5px" }}
                            label={field.label}
                            value={formData[field.name] || null}
                            onChange={(date) => {
                              onFieldChange({
                                target: {
                                  name: field.name,
                                  value: date,
                                },
                              });
                            }}
                            format="DD/MM/yyyy"
                            animateYearScrolling
                            error={hasError}
                            helperText={helperText}
                            //disabled={isEditMode || isView}
                            fullWidth
                          />
                        </ThemeProvider>
                      </MuiPickersUtilsProvider>
                    </Grid>
                  ) : field.type === "file-image" ? (
                    <Grid item xs={12}>
                      {!isView && (
                        <input
                          accept={field.accept || "*/*"}
                          className={classes.input}
                          id={field.name}
                          type="file"
                          onChange={(e) => handleFileChange(e, field.name)}
                          name={field.name}
                          ref={fileInputRef} // ⚠️ Podrías necesitar useRef() si fueras a hacer un único input
                          style={{ marginBottom: "5px" }}
                          disabled={isView}
                        />
                      )}
                      {hasError && (
                        <p
                          style={{
                            color: "red",
                            fontSize: "0.75rem",
                            marginTop: "-5px",
                          }}
                        >
                          {helperText}
                        </p>
                      )}
                      {isView && formData[field.name] && (
                        <p
                          style={{
                            color: "gray",
                            fontSize: "0.9rem",
                            marginTop: "-5px",
                          }}
                        >
                          {formData[field.label]}
                        </p>
                      )}
                    </Grid>
                  ) : field.type === "radio" ? (
                    <Grid item xs={isModalRadication ? 3 : 12}>
                      <FormControl
                        component="fieldset"
                        error={hasError}
                        required={
                          field.required || requiredFields.includes(field.name)
                        }
                      >
                        <FormLabel>{field.label}</FormLabel>
                        <RadioGroup
                          row // Opcional: coloca los botones en una fila
                          name={field.name}
                          value={
                            formData[field.name] !== undefined
                              ? String(formData[field.name])
                              : String(field.defaultValue ?? "")
                          }
                          onChange={(e) => {
                            const rawValue = e.target.value;
                            // CONVERSIÓN CRÍTICA: Convertir el string de nuevo a booleano
                            let formattedValue = rawValue;
                            if (rawValue === "true") formattedValue = true;
                            if (rawValue === "false") formattedValue = false;

                            // Llamamos a la función que actualiza el estado con el tipo de dato correcto
                            onFieldChange({
                              target: {
                                name: field.name,
                                value: formattedValue,
                              },
                            });
                          }}
                          disabled={isView}
                        >
                          {(
                            field.options || [
                              { value: true, label: "Sí" },
                              { value: false, label: "No" },
                            ]
                          ).map((option) => (
                            <FormControlLabel
                              key={String(option.value)}
                              value={String(option.value)}
                              control={<Radio color="primary" />}
                              label={option.label}
                              disabled={isView}
                            />
                          ))}
                        </RadioGroup>
                        {hasError && (
                          <p
                            style={{
                              color: "red",
                              fontSize: "0.75rem",
                              marginTop: 0,
                            }}
                          >
                            {helperText}
                          </p>
                        )}
                      </FormControl>
                    </Grid>
                  ) : field.type === "autocomplete-checkbox" ? (
                    <Grid item xs={isModalRadication ? 3 : 12}>
                      <Autocomplete
                        multiple
                        id={field.name}
                        name={field.name}
                        options={field.options || []}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option.label}
                        value={
                          (formData[field.name] || [])
                            .map(
                              (value) =>
                                field.options.find(
                                  (opt) => opt.value === value,
                                ) || { value, label: `${value}` },
                            )
                            .filter((opt) => opt) // Convierte los valores (ej: IDs) a objetos de opción
                        }
                        onChange={(event, newValue) => {
                          // Mapea los objetos de opción seleccionados de vuelta a sus 'value' (ej: IDs)
                          const values = newValue.map((option) => option.value);

                          onFieldChange({
                            // Simula el evento de cambio para onFieldChange
                            target: {
                              name: field.name,
                              value: values,
                            },
                          });
                        }}
                        renderOption={(option, { selected }) => (
                          <React.Fragment>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            {option.label}
                          </React.Fragment>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            required
                            label={field.label}
                            placeholder={field.placeholder || "Selecciona..."}
                            style={{ marginBottom: "5px" }}
                            disabled={isView}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            error={hasError}
                            helperText={helperText}
                          />
                        )}
                        fullWidth
                        disabled={isView || !!field.readOnly}
                      />
                    </Grid>
                  ) : field.type === "checkbox-boolean" ? (
                    <Grid item xs={isModalRadication ? 6 : 12}>
                      <FormControl
                        error={!!validationErrors[field.name]} // MUI marcará el error
                        component="fieldset"
                        //error={hasError}
                        required={
                          field.required || requiredFields.includes(field.name)
                        }
                      >
                        <FormControlLabel
                          control={
                            <Checkbox
                              required={field.required}
                              checked={!!formData[field.name]}
                              onChange={(e) => {
                                onFieldChange({
                                  target: {
                                    name: field.name,
                                    value: e.target.checked,
                                  },
                                });
                              }}
                              color="primary"
                              disabled={isView}
                            />
                          }
                          label={field.label || field.text}
                        />
                        {hasError && (
                          <p
                            style={{
                              color: "red",
                              fontSize: "0.75rem",
                              marginTop: 0,
                            }}
                          >
                            {helperText}
                          </p>
                        )}
                      </FormControl>
                    </Grid>
                  ) : field.type === "autocomplete-texto" ? (
                    <Grid
                      item
                      xs={isModalRadication ? 3 : isModalUser ? 4 : 12}
                      key={field.name}
                    >
                      <Autocomplete
                        id={field.name}
                        options={field.options || []}
                        getOptionLabel={(option) =>
                          option ? `${option.codigo} - ${option.label}` : ""
                        }
                        value={
                          Array.isArray(formData[field.name])
                            ? (field.options || []).filter((opt) =>
                                formData[field.name].includes(opt.value),
                              ) // Si es múltiple
                            : (field.options || []).find(
                                (opt) => opt.value === formData[field.name],
                              ) || null // Si es simple
                        }
                        onChange={(event, newValue) => {
                          let valueToSave;

                          if (Array.isArray(newValue)) {
                            valueToSave = newValue.map(
                              (option) => option.id || option.value,
                            );
                          } else {
                            valueToSave = newValue
                              ? newValue.id || newValue.value
                              : null;
                          }

                          onFieldChange({
                            target: {
                              name: field.name,
                              value: valueToSave,
                            },
                          });
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={field.label}
                            margin="normal"
                            error={hasError}
                            helperText={hasError ? helperText : ""}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        )}
                        disabled={isView}
                      />
                    </Grid>
                  ) : field.type === "checkbox-group" ? (
                    <Grid item xs={12} /* key={field.name} */>
                      <FormControl
                        component="fieldset"
                        error={hasError}
                        required={
                          field.required || requiredFields.includes(field.name)
                        }
                      >
                        <FormLabel component="legend">{field.label}</FormLabel>
                        <Grid
                          container
                          spacing={1}
                          style={{ marginButtom: "0px" }}
                        >
                          {(field.options || []).map((option) => (
                            <Grid item xs={4} key={option.value}>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={(
                                      formData[field.name] || []
                                    ).includes(option.value)}
                                    onChange={(e) => {
                                      const currentValues =
                                        formData[field.name] || [];
                                      const isChecked = e.target.checked;
                                      let newValues = [];

                                      if (isChecked) {
                                        newValues = [
                                          ...currentValues,
                                          option.value,
                                        ];
                                      } else {
                                        newValues = currentValues.filter(
                                          (v) => v !== option.value,
                                        );
                                      }

                                      onFieldChange({
                                        target: {
                                          name: field.name,
                                          value: newValues, // Array de valores seleccionados
                                        },
                                      });
                                    }}
                                  />
                                }
                                label={option.label}
                                disabled={isView}
                                style={{ width: "100%" }} // Ajuste visual
                              />
                            </Grid>
                          ))}
                        </Grid>
                        {hasError && (
                          <p
                            style={{
                              color: "red",
                              fontSize: "0.75rem",
                              marginTop: 0,
                            }}
                          >
                            {helperText}
                          </p>
                        )}
                      </FormControl>
                    </Grid>
                  ) : field.type === "list-documentos" ? (
                    <Grid item xs={12}>
                      <FormControl
                        component="fieldset"
                        error={hasError}
                        required={
                          field.required || requiredFields.includes(field.name)
                        }
                        fullWidth
                      >
                        <FormLabel
                          component="legend"
                          style={{
                            marginBottom: "10px",
                            fontWeight: "bold",
                            color: "rgba(0, 0, 0, 0.6)",
                          }}
                        >
                          {field.label}
                        </FormLabel>

                        <Grid container spacing={2}>
                          {field.options && field.options.length > 0 ? (
                            field.options.map((option) => {
                              const archivoPrevio = formData.documentos?.find(
                                (doc) =>
                                  String(doc.id_documento_convocatoria) ===
                                  String(option.value),
                              );

                              return (
                                <Grid item xs={12} sm={6} key={option.value}>
                                  <Box
                                    sx={{
                                      border: "1px solid #ccc",
                                      borderRadius: 1,
                                      display: isView ? "flex" : "block",
                                      alignItems: isView ? "center" : "initial",
                                    }}
                                  >
                                    <Typography
                                      variant="caption"
                                      display="block"
                                      gutterBottom
                                    >
                                      {option.label}
                                    </Typography>

                                    {archivoPrevio &&
                                    (!isEditMode || isView) ? (
                                      <IconButton
                                        style={{color: '#F87C63'}}
                                        onClick={() =>
                                          setSelectedDocId(
                                            archivoPrevio.id_documento_convocatoria,
                                          )
                                        }
                                      >
                                        <PictureAsPdfIcon />
                                      </IconButton>
                                    ) : null}

                                    <Modal
                                      open={
                                        selectedDocId ===
                                        archivoPrevio?.id_documento_convocatoria
                                      }
                                      onClose={() => setSelectedDocId(null)}
                                      style={{
                                        zIndex: 1500,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <div
                                        style={{
                                          backgroundColor: "white",
                                          padding: "20px",
                                          borderRadius: "8px",
                                          width: "50%",
                                          height: "80%",
                                        }}
                                      >
                                        <IconButton
                                          style={{ float: "right" }}
                                          onClick={() => setSelectedDocId(null)}
                                        >
                                          <CloseIcon />
                                        </IconButton>

                                        <iframe
                                          title={`Visualizador-${archivoPrevio?.id_documento_convocatoria}`}
                                          width="100%"
                                          height="90%"
                                          src={`${process.env.REACT_APP_PUBLIC_URL}documentos-proveedores/ver/${archivoPrevio?.id_documento_convocatoria}/${archivoPrevio?.id_proveedores}/${sessionStorage.getItem("token")}`}
                                        ></iframe>
                                      </div>
                                    </Modal>

                                    {(isEditMode && isRegister) || !isView ? (
                                      <input
                                        type="file"
                                        accept=".pdf"
                                        onChange={(e) =>
                                          handleListFileChange(e, option.value)
                                        }
                                      />
                                    ) : null}

                                    {archivoPrevio && !isView && (
                                      <Typography
                                        variant="body2"
                                        style={{
                                          fontSize: "0.8rem",
                                          margin: "4px 0",
                                          display: "flex",
                                          alignItems: "center",
                                          color:"green"
                                        }}
                                      >
                                        {archivoPrevio.nombre_documento}
                                      </Typography>
                                    )}
                                  </Box>
                                </Grid>
                              );
                            })
                          ) : (
                            <Grid item xs={12}>
                              <Typography variant="body2" color="textSecondary">
                                No hay documentos requeridos.
                              </Typography>
                            </Grid>
                          )}
                        </Grid>

                        {hasError && (
                          <FormHelperText error>{helperText}</FormHelperText>
                        )}

                        {isView && formData[field.name] && (
                          <p
                            style={{
                              color: "gray",
                              fontSize: "0.9rem",
                              marginTop: "-5px",
                            }}
                          >
                            {formData[field.label]}
                          </p>
                        )}
                      </FormControl>
                    </Grid>
                  ) : field.type === "textarea" ? (
                    <Grid item xs={6}>
                      <TextField
                        id={field.name}
                        label={field.label}
                        name={field.name}
                        className="medical-material-form__field field-appointment-mod"
                        style={{ marginBottom: "5px" }}
                        InputLabelProps={{ shrink: true }}
                        type="text"
                        fullWidth
                        required={field.required !== false}
                        multiline
                        value={formData[field.name] || ""}
                        onChange={onFieldChange}
                        disabled={isView || !!field.readOnly}
                        error={hasError}
                        helperText={helperText}
                      />
                    </Grid>
                  ) : field.type === "label" ? (
                    <Grid item xs={12}>
                      <Typography
                        variant={"body1"}
                        className="medical-material-form__field field-appointment-mod MuiInputBase-input.Mui-disabled"
                        component={"label"}
                        htmlFor={"label"}
                        style={{ color: "#289BFF" }}
                      >
                        {field.text || field.label}
                      </Typography>
                    </Grid>
                  ) : field.type === "parrafo" ? (
                    <Grid item xs={isModalRadication ? 3 : 12}>
                      <Typography
                        variant={"body2"}
                        className="medical-material-form__field field-appointment-mod MuiInputBase-input.Mui-disabled"
                        component={"label"}
                        htmlFor={"label"}
                      >
                        {field.text || field.label}
                      </Typography>
                    </Grid>
                  ) : field.type === "link" ? (
                    <Grid item xs={isModalRadication ? 3 : 12}>
                      <Link
                        required={true}
                        href={field.url || formData[field.name] || "#"}
                        target={field.target || "_blank"}
                        rel={field.rel || "noopener noreferrer"}
                        style={{
                          color: "#1976d2",
                          textDecoration: "underline",
                          fontSize: "1rem",
                          display: "flex",
                          alignItems: "center",
                        }}
                        onClick={(e) => {
                          if (field.onClick) {
                            e.preventDefault();
                            field.onClick(formData);
                          }
                        }}
                      >
                        {field.icon && <field.icon />}
                        {field.text || field.label}
                      </Link>
                    </Grid>
                  ) : field.type === "label2" ? (
                    <Grid item xs={isModalRadication ? 3 : 12}>
                      <h5>Foto de perfil</h5>
                    </Grid>
                  ) : field.type === "mayuscula" ? (
                    <Grid
                      item
                      xs={
                        isModalRol
                          ? 6
                          : isModalRadication
                            ? 3
                            : isModalUser
                              ? 4
                              : 12
                      }
                    >
                      <TextField
                        id={field.name}
                        label={field.label}
                        name={field.name}
                        className="medical-material-form__field field-appointment-mod"
                        style={{ marginBottom: "5px" }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        type={field.type}
                        fullWidth
                        required
                        value={formData[field.name] || ""}
                        onChange={onFieldChangeMay}
                        disabled={isView || !!field.readOnly}
                        error={hasError}
                        helperText={helperText}
                      />
                    </Grid>
                  ) : field.type === "email" ? (
                    <Grid
                      item
                      xs={
                        isModalRol
                          ? 6
                          : isModalRadication
                            ? 3
                            : isModalUser
                              ? 4
                              : 12
                      }
                    >
                      <TextField
                        id={field.name}
                        label={field.label}
                        name={field.name}
                        className="medical-material-form__field field-appointment-mod"
                        style={{ marginBottom: "5px" }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        type={field.type}
                        fullWidth
                        required
                        value={formData[field.name] || ""}
                        onChange={onFieldChangeMini}
                        disabled={isView || !!field.readOnly}
                        error={hasError}
                        helperText={helperText}
                      />
                    </Grid>
                  ) : field.type === "optionalField" ? (
                    <Grid item xs={isModalRadication ? 3 : 12}>
                      <Autocomplete
                        multiple
                        id={field.name}
                        name={field.name}
                        options={field.options || []} // Usa las opciones pasadas
                        disableCloseOnSelect
                        getOptionLabel={(option) => option.label} // Asume que la opción tiene 'label'
                        value={(() => {
                          const currentVal = formData[field.name];
                          if (Array.isArray(currentVal)) {
                            return currentVal.map(
                              (v) =>
                                field.options.find((o) => o.value === v) || {
                                  value: v,
                                  label: `ID: ${v}`,
                                },
                            );
                          }
                          // Si es un objeto tipo { "15": "Nombre" }, extraemos las llaves para que el Autocomplete lo reconozca
                          if (currentVal && typeof currentVal === "object") {
                            return Object.keys(currentVal).map((key) => ({
                              value: key,
                              label: currentVal[key],
                            }));
                          }
                          return [];
                        })()}
                        onChange={(event, newValue) => {
                          // Mapea los objetos de opción seleccionados de vuelta a sus 'value' (ej: IDs)
                          const values = newValue.map((option) => option.value);

                          onFieldChange({
                            // Simula el evento de cambio para onFieldChange
                            target: {
                              name: field.name,
                              value: values,
                            },
                          });
                        }}
                        renderOption={(option, { selected }) => (
                          <React.Fragment>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            {option.label}
                          </React.Fragment>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={field.label}
                            placeholder={field.placeholder || "Selecciona..."}
                            style={{ marginBottom: "5px" }}
                            disabled={isView}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            error={hasError}
                            helperText={helperText}
                          />
                        )}
                        fullWidth
                        disabled={isView || !!field.readOnly}
                      />
                    </Grid>
                  ) : field.type === "codigo" ? (
                    <Grid
                      item
                      xs={
                        isModalRol
                          ? 6
                          : isModalRadication
                            ? 3
                            : isModalUser
                              ? 4
                              : 12
                      }
                    >
                      <TextField
                        id={field.name}
                        label={field.label}
                        name={field.name}
                        className="medical-material-form__field field-appointment-mod"
                        style={{ marginBottom: "3px" }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        placeholder="Ingrese el código"
                        type="text"
                        inputProps={{
                          maxLength: 6,
                          inputMode: "numeric",
                          pattern: "[0-9]*",
                        }}
                        fullWidth
                        required
                        value={formData[field.name] || ""}
                        onChange={(e) => {
                          // mantener sólo dígitos y cortar a 6 caracteres
                          let val = e.target.value.replace(/\D/g, "");
                          if (val.length > 6) val = val.slice(0, 6);
                          onFieldChange({
                            target: {
                              name: field.name,
                              value: val,
                            },
                          });
                        }}
                        disabled={isView || !!field.readOnly}
                        error={hasError}
                        helperText={helperText}
                      />
                    </Grid>
                  ) : field.type === "password" ? (
                    <Grid
                      item
                      xs={isModalUser ? 4 : isModalRadication ? 3 : 12}
                    >
                      <TextField
                        id={field.name}
                        label={field.label}
                        name={field.name}
                        className="medical-material-form__field field-appointment-mod"
                        style={{ marginBottom: "3px" }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        type="password"
                        fullWidth
                        required
                        value={formData[field.name] || ""}
                        onChange={onFieldChange}
                        disabled={isView || !!field.readOnly}
                        error={hasError}
                        helperText={helperText}
                        autoComplete="new-password"
                      />
                    </Grid>
                  ) : field.type === "texto-disabled" ? (
                    <Grid
                      item
                      xs={isModalUser ? 4 : isModalRadication ? 3 : 12}
                    >
                      <TextField
                        id={field.name}
                        label={field.label}
                        name={field.name}
                        className="medical-material-form__field field-appointment-mod"
                        style={{ marginBottom: "3px" }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        type={field.type}
                        fullWidth
                        required
                        value={formData[field.name] || ""}
                        onChange={onFieldChange}
                        disabled={isView || isEditMode || !!field.readOnly}
                        error={hasError}
                        helperText={helperText}
                      />
                    </Grid>
                  ) : (
                    <Grid
                      item
                      xs={
                        isModalRol
                          ? 6
                          : isModalRadication
                            ? 3
                            : isModalUser
                              ? 4
                              : 12
                      }
                    >
                      <TextField
                        id={field.name}
                        label={field.label}
                        name={field.name}
                        className="medical-material-form__field field-appointment-mod"
                        style={{ marginBottom: "3px" }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        type={field.type}
                        fullWidth
                        required
                        value={formData[field.name] || ""}
                        onChange={onFieldChange}
                        disabled={isView || !!field.readOnly}
                        error={hasError}
                        helperText={helperText}
                      />
                    </Grid>
                  )}
                </React.Fragment>
              );
            })}
            {children}

            <Grid item xs={12}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                  justifyContent: "flex-end",
                }}
              >
                <Button variant="contained" onClick={onClose}>
                  Cerrar
                </Button>
                {!isView && (
                  <Button
                    className="btn btn-sm"
                    color="primary"
                    onClick={() => handleSave()}
                  >
                    {`${
                      isUploadDoc
                        ? "Guardar"
                        : isEditMode
                          ? "Actualizar "
                          : enableDobleAutentication
                            ? "Siguiente"
                            : "Crear "
                    }`}
                  </Button>
                )}
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    </Modal>
  );
}
